import { QueryClient } from "@tanstack/react-query";

/**
 * QueryClient for desktop.
 *
 * Uten egen klient lager ra-core en `new QueryClient()` med `staleTime: 0`,
 * slik at alt på skjermen hentes på nytt ved hver navigering og hvert
 * fanebytte. Med en kort `staleTime` vises cachede data umiddelbart når man
 * går tilbake til en side, uten en ny runde mot Supabase.
 *
 * ra-cores egne mutasjoner (create/update/delete) oppdaterer eller
 * invaliderer cachen selv, og `refresh()` invaliderer alt, så endringer
 * gjort i appen vises fortsatt med en gang.
 */
export const DEFAULT_STALE_TIME = 15 * 1000;

export const createDesktopQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: DEFAULT_STALE_TIME,
      },
    },
  });
